export class ToolBeltPickupAction {
    constructor(parentUid, params, description) {
        this.parentUid = parentUid;
        this.params = params;
        this.description = description;
        this.action = ToolBeltPickupAction.typestatic;
    }
    static is(params) {
        return params.action === ToolBeltPickupAction.typestatic;
    }
}
ToolBeltPickupAction.typestatic = "ToolBeltPickupAction";
